// SectionIphoneComponent.tsx

import React, { useState, useEffect } from "react";
import * as S from './styles';
import IPhoneComponent from "@/components/IPhone";
import gifStep1 from '../../img/vip.mp4';
import gifStep2 from '../../img/2.mp4';
import gifStep3 from '../../img/3.mp4';
import gifStep4 from '../../img/4.mp4';
import gifStep5 from '../../img/1.mp4';

const SectionIphoneComponent: React.FC = () => {
    const videoSrcs = [gifStep1, gifStep3, gifStep2, gifStep4, gifStep5];
    const titles = ['Grupo VIP', 'Análises Precisas', 'Métricas Detalhadas', 'Informações Completas', 'Integração de Odds'];

    const [activeStep, setActiveStep] = useState(0);
    const [autoplay, setAutoplay] = useState(true);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setActiveStep((prevStep) => (prevStep + 1) % videoSrcs.length);
            setAutoplay(true); // Garante que o autoplay seja true a cada intervalo
        }, 10000);

        return () => clearInterval(intervalId);
    }, []);

    const handleStepClick = (index: number) => {
        setActiveStep(index);
        setAutoplay(false); // Desativa o autoplay quando uma opção do timeline é clicada
    };

    return (
        <>
            <S.SectionMacbook>
                <S.RowCTA>
                    <h1>PORQUE ESCOLHER O <b>Futscore</b>? </h1>
                    <br />
                    <p>
                        Explore nosso software através de uma demonstração interativa!
                    </p>
                    <br />
                    <p>Descubra como nossas funcionalidades podem otimizar suas operações e aumentar sua eficiência.   </p>
                    <br />
                    <p>Venha descobrir o potencial do nosso software hoje!</p>
                    <br />
                </S.RowCTA>
                <div className="row-primary">
                    <div className="col-cta">
                        <S.Timeline>
                            {titles.map((title, index) => (
                                <S.TimelineItem key={index} className={index === activeStep ? 'active' : ''} onClick={() => handleStepClick(index)}>
                                    {title}  <b>{index + 1}.</b>
                                </S.TimelineItem>
                            ))}
                        </S.Timeline>
                    </div>
                    <div className="col-mac">
                        {videoSrcs.map((src, index) => (
                            <IPhoneComponent key={index} src={src} active={index === activeStep} />
                        ))}
                    </div>
                </div>
            </S.SectionMacbook>
        </>
    );
};

export default SectionIphoneComponent;
